import { Signal, isSignal } from '@angular/core';
import { UTILS } from './utils';

export type ValidatorOptions = {
  isWarning?: boolean;
  message?: string;
};

export class Validator {
  #value?: unknown;
  warnings?: Array<string> = [];
  errors?: Array<string> = [];
  instance?: Validator;

  constructor(value?: unknown) {
    this.#value = value;
  }

  get value(): unknown {
    return isSignal(this.#value) ? this.#value() : this.#value;
  }

  static set(value?: unknown): Validator {
    return new Validator(value);
  }

  static messages = {
    error: {
      required: 'Should not be empty',
      equals: 'Should be equal to',
      notEquals: 'Should not be equal to',
      min: 'Should not be less than',
      minIncluding: 'Should not be less or equal to',
      max: 'Should not be more than',
      maxIncluding: 'Should not be more or equal to',
    },
    warning: {
      required: 'Is usually not empty',
      equals: 'Is usually equal to',
      notEquals: 'Is usually not equal to',
      min: 'Is usually not less than',
      minIncluding: 'Is usually not less or equal to',
      max: 'Is usually not more than',
      maxIncluding: 'Is usually not more or equal to',
    },
  };

  required(options?: ValidatorOptions): Validator {
    this.errors = UTILS.OBJECT.isEmpty(this.#value)
      ? [
          ...(this.errors ?? []),
          (options?.message ?? options?.isWarning)
            ? Validator.messages.warning.required
            : Validator.messages.error.required,
        ]
      : this.errors;
    return this;
  }

  min(min?: number | Signal<number>, options?: ValidatorOptions): Validator {
    const minPlain = isSignal(min) ? min() : min;
    this.errors =
      !UTILS.OBJECT.isNil(minPlain) &&
      (this.value as number) < (minPlain as number)
        ? [
            ...(this.errors ?? []),
            options?.message ??
              `${options?.isWarning ? Validator.messages.warning.min : Validator.messages.error.min} ${minPlain}`,
          ]
        : this.errors;
    return this;
  }

  max(max?: number | Signal<number>, options?: ValidatorOptions): Validator {
    const maxPlain = isSignal(max) ? max() : max;
    this.errors =
      !UTILS.OBJECT.isNil(maxPlain) &&
      (this.value as number) > (maxPlain as number)
        ? [
            ...(this.errors ?? []),
            options?.message ??
              `${options?.isWarning ? Validator.messages.warning.max : Validator.messages.error.max} ${maxPlain}`,
          ]
        : this.errors;
    return this;
  }
}
